import 'react-app-polyfill/ie9';
import 'core-js/features/array/find';
import 'core-js/features/array/fill';
import 'core-js/features/array/includes';
import 'core-js/features/array/find-index';
import 'core-js/features/number/is-nan';
import 'core-js/features/number/is-integer';
import 'core-js/features/string/repeat';
import 'core-js/features/string/includes';
import 'core-js/features/string/repeat';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { I18nextProvider } from 'react-i18next';

import { Provider } from 'react-redux';
import store from './store';

import App from './App';
import './index.css';
import i18n from './translation/i18n';
import {unregister} from './registerServiceWorker';

import { BrowserRouter } from 'react-router-dom';

ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </I18nextProvider>
  </Provider>,
  document.getElementById('root') as HTMLElement
);
unregister();
